import React, { useState, createRef, useEffect } from "react";
import Auth_brand from "./Auth_brand";
import { redirect, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import config from "../../config";

const Login = () => {
  let navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const pendingInstall = searchParams.get("pendingShopifyInstall");
  let userDetail = localStorage.getItem("ship_rocket_user");
  // console.log("userDetail ===>   ",userDetail);
  const [state, setState] = useState({
    email: "",
    password: "",
    type: config.type,
  });

  const [userState, setUserState] = useState({ full_name: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    if (pendingInstall) {
      Swal.fire({
        icon: "info",
        title: "Please log in",
        text: "Your Shopify store will be connected automatically after login.",
        timer: 4000,
        showConfirmButton: true,
      });
    }
  }, [pendingInstall]);

  useEffect(() => {
    if (userDetail != null) {
      let uDetail = JSON.parse(userDetail);
      setUserState({ full_name: uDetail.full_name });
      config.UserId = uDetail.customer_id;
    }
  }, []);

  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    showConfirmButton: false,
    timer: 3000,
  });

  const inputHandleChange = (e) => {
    const value = e.target.value;
    const text = e.target.name;
    setState({ ...state, [text]: value });
  };

  const loginButton = async () => {
    console.log("state => ", state);

    if (!state.email || !state.password) {
      Toast.fire({
        background: "#a61c09",
        icon: "error",
        title: "Please fill both fields",
        color: "white",
      });

      return;
    }

    try {
      setIsLoading(true);

      const full_api = `${config.apiUrl}/user/login_api`;

      const response = await axios.post(full_api, state, {
        headers: config.headers,
      });

      const data = response.data;

      console.log("login response =>", data);

      if (data?.isValid) {
        if (data?.isotp === true) {
          localStorage.setItem("ship_rocket_user", JSON.stringify(data.output));

          localStorage.setItem("kyc_checked", "false");

          localStorage.removeItem("hasSeenCarousel");

          setUserState({
            full_name: data.output.full_name,
          });

          config.UserId = data.output.customer_id;

          const pending = new URLSearchParams(window.location.search).get(
            "pendingShopifyInstall"
          );

          window.location.replace(
            pending
              ? `/index?pendingShopifyInstall=${encodeURIComponent(pending)}`
              : "/index"
          );

          return;
        }

        /*
         * STAFF LOGIN / OTP
         */
        const otpResponse = await axios.post(
          `${config.apiUrl}/user/otp_sent_for_staff`,
          {
            customer_email: data.email,
            staff_email: state.email,
          },
          {
            headers: config.headers,
          }
        );

        if (otpResponse.data?.isValid) {
          Toast.fire({
            background: "#3659cd",
            icon: "success",
            title: otpResponse.data.message,
            color: "white",
          });

          navigate("/staff_otp_verification", {
            state: {
              email: data.email,
              mobile_number: "",
              staff_email: state.email,
            },
          });
        } else {
          Toast.fire({
            background: "#a61c09",
            icon: "error",
            title: otpResponse.data?.message || "Unable to send OTP.",
            color: "white",
          });
        }

        return;
      }

      Toast.fire({
        background: "#a61c09",
        icon: "error",
        title: data?.message || "Invalid login credentials.",
        color: "white",
      });
    } catch (error) {
      console.error("login error =>", error);

      Toast.fire({
        background: "#a61c09",
        icon: "error",
        title: error?.response?.data?.message || "Something went wrong.",
        color: "white",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const naviagte_to_forgot = () => {
    if (state.email != "") {
      let full_api = config.apiUrl + `/user/forgot_password`;
      let sendData = { email: state.email };
      // console.log("bb", sendData);
      axios
        .post(full_api, sendData, { headers: config.headers })
        .then((res) => {
          // console.log("res ", res);
          if (res.data.isValid) {
            Toast.fire({
              background: "#3659cd",
              type: "success",
              title: res.data.message,
              color: "white",
            });
          } else {
          }
        });
      let sendState = { email: state.email };
      // console.log("sendState === " , sendState)

      navigate("/forgot_otp", { state: sendState });
    } else {
      Toast.fire({
        background: "#a61c09",
        type: "unsuccess",
        title: "Please Enter Email",
        color: "white",
      });
    }
  };
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/assets/js/elite.js?v=27";
    script.async = false;

    document.body.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);
  return (
    <div>
      <section class="auth-page">
        <div class="auth-form-panel">
          <div class="auth-form-wrap">
            <header>
              <a href="/login" class="auth-logo" aria-label="SkyShip home">
                <span class="auth-logo-mark">S</span>
                <span class="auth-logo-name">SkyShip</span>
              </a>

              <div class="auth-heading">
                <h1 class="auth-title">Welcome back</h1>
                <p class="auth-subtitle">
                  Sign in to your logistics dashboard to continue managing your
                  shipments.
                </p>
              </div>
            </header>

            <form
              class="auth-form"
              onSubmit={(e) => {
                e.preventDefault();
                console.log("LOGIN FORM SUBMIT");
                loginButton();
              }}
            >
              <div class="auth-field">
                <label class="form-label" for="email">
                  Email address
                </label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  placeholder="you@company.com"
                  autocomplete="email"
                  name="email"
                  onChange={(e) => inputHandleChange(e)}
                  autofocus
                  required
                />
              </div>

              <div class="auth-field">
                <label class="form-label" for="password">
                  Password
                </label>
                <div className="auth-password">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="password"
                    name="password"
                    value={state.password}
                    onChange={inputHandleChange}
                    placeholder="Enter your password"
                    autoComplete="current-password"
                    required
                  />

                  <button
                    type="button"
                    className="auth-eye"
                    onClick={() => setShowPassword((prev) => !prev)}
                    aria-label={
                      showPassword ? "Hide password" : "Show password"
                    }
                    aria-pressed={showPassword}
                  >
                    <i
                      className={`bi ${
                        showPassword ? "bi-eye-slash" : "bi-eye"
                      }`}
                    ></i>
                  </button>
                </div>
              </div>

              <div class="auth-options">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="rememberPassword"
                    name="remember"
                  />
                  <label class="form-check-label" for="rememberPassword">
                    Remember me
                  </label>
                </div>
                <a
                  style={{ cursor: "pointer" }}
                  onClick={(e) => naviagte_to_forgot(e)}
                  class="auth-forgot"
                >
                  Forgot password?
                </a>
              </div>

              <button
                type="submit"
                className={`btn btn-primary auth-submit ${
                  isLoading ? "is-loading" : ""
                }`}
                disabled={isLoading}
              >
                <span className="auth-spinner" aria-hidden="true"></span>

                <span className="auth-submit-label">
                  {isLoading ? "Signing in..." : "Sign in"}
                </span>

                {!isLoading && <i className="bi bi-arrow-right"></i>}
              </button>

              <div class="auth-divider">
                <span>or continue with</span>
              </div>

              <div class="auth-socials">
                <button type="button" class="btn auth-social">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      fill="#4285F4"
                      d="M23.49 12.27c0-.79-.07-1.54-.19-2.27H12v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z"
                    />
                    <path
                      fill="#34A853"
                      d="M12 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96H1.29v3.09C3.26 21.3 7.31 24 12 24z"
                    />
                    <path
                      fill="#FBBC05"
                      d="M5.27 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62H1.29C.47 8.24 0 10.06 0 12s.47 3.76 1.29 5.38l3.98-3.09z"
                    />
                    <path
                      fill="#EA4335"
                      d="M12 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C17.95 1.19 15.24 0 12 0 7.31 0 3.26 2.7 1.29 6.62l3.98 3.09C6.22 6.86 8.87 4.75 12 4.75z"
                    />
                  </svg>
                  Continue with Google
                </button>
                <button type="button" class="btn auth-social">
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path
                      fill="#96BF48"
                      d="M20.8 6.2h-2.9l-.4-1.4c-.3-1.1-1-1.6-1.9-1.6H13l-.1-2.1c-.1-.4-.3-.8-.8-1-1-.2-2 .2-2.5 1.2L8.8 3.5H7.9c-.9 0-1.6.5-1.9 1.6L5.6 6.2H3.2c-.4 0-.7.3-.7.7 0 5.7.3 11.4-.6 15.2 0 .3.2.5.5.5h18.7c.3 0 .5-.2.5-.5-1-3.8-.8-9.5-.8-15.2 0-.4-.3-.7-.7-.7zM9.3 4.2c.2-.4.6-.6 1-.6.4 0 .6.2.5.6l.2 1.5H9.1l.2-1.5zm3.1 0c.2-.4.6-.6 1-.6.4 0 .6.2.5.6l.2 1.5h-1.7l0-1.5z"
                    />
                  </svg>
                  Continue with Shopify
                </button>
              </div>
            </form>

            <p class="auth-signup">
              Don't have an account? <a href="/register">Create one</a>
            </p>
          </div>
        </div>

        <Auth_brand />
      </section>
    </div>
  );
};

export default Login;
